import React from 'react';
import { decrypt } from '../../utils/security';

const GRADIENTS = [
  'linear-gradient(150deg,#D4A5A3,#C08A88)',
  'linear-gradient(150deg,#A3B4CC,#8898B8)',
  'linear-gradient(150deg,#A3C4B4,#88AE9E)',
  'linear-gradient(150deg,#C4B488,#AE9E74)',
  'linear-gradient(150deg,#B4A3C8,#9E88B4)',
  'linear-gradient(150deg,#C4A3B4,#AE8E9E)',
];

const BookListCard = ({ book, onClick, onOpenFullBook }) => {
  const encryptedTitle = book.book_name || book.book_title || book.title || '—';
  const title = decrypt(encryptedTitle);
  const idx = (book._id || book.id || 0) % GRADIENTS.length;
  const grad = GRADIENTS[Math.abs(idx)];
  const rawCover = book.images?.small || book.category?.cover_image_small || null;
  const coverImage = (rawCover && (rawCover.startsWith('data:image') || rawCover.startsWith('http'))) ? rawCover : null;

  // Clean summary for display
  const rawSummary = book.book_summary || '';
  const cleanSummary = rawSummary.replace(/<[^>]*>?/gm, '').trim();
  const isLong = cleanSummary.length > 150;
  const summaryText = cleanSummary.substring(0, 150);

  return (
    <div
      className="flex flex-row bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 border cursor-pointer"
      style={{ borderColor: 'var(--border)', minHeight: 180 }}
      onClick={onClick}
    >
      {/* Cover Image */}
      <div
        className="flex-shrink-0 relative flex"
        style={{
          width: 140,
          background: coverImage ? `url("${coverImage}") center/cover` : grad
        }}
      >
        {/* Spine shadow for premium 3D book depth */}
        <div className="absolute left-0 top-0 bottom-0 w-1.5" style={{ background: 'linear-gradient(90deg, rgba(0,0,0,0.15), transparent)' }} />
        <div className="absolute left-1.5 top-0 bottom-0 w-0.5" style={{ background: 'rgba(255,255,255,.15)' }} />

        {!coverImage && (
          <div className="absolute inset-0 flex flex-col justify-end" style={{ padding: '12px', background: 'linear-gradient(transparent 30%, rgba(0,0,0,0.55))' }}>
            <div className="font-ui font-semibold text-white leading-snug" style={{ fontSize: 11, fontFamily: 'Nunito,sans-serif', textShadow: '1px 1px 2px rgba(0,0,0,0.4)' }}>
              {title}
            </div>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 p-4 flex flex-col justify-between">
        <div>
          <h3 className="font-bold text-lg mb-1" style={{ color: 'var(--ink)', fontFamily: 'Nunito,sans-serif' }}>{title}</h3>



          <div className="text-sm mt-2" style={{ color: 'var(--ink-lt)', fontFamily: 'Nunito,sans-serif' }}>
            {summaryText ? (
              <>
                {summaryText}
                {isLong && (
                  <span>
                    ... <span className="font-bold hover:underline" style={{ color: 'var(--rose)' }}>See more</span>
                  </span>
                )}
              </>
            ) : (
              'A comprehensive legal study material and commentary.'
            )}
          </div>
        </div>

        <div className="mt-4 flex items-center">
          <button
            onClick={(e) => { e.stopPropagation(); onOpenFullBook(book); }}
            className="px-6 py-2 text-white font-bold rounded-md transition-opacity hover:opacity-90"
            style={{ background: 'var(--rose)', fontSize: 13, fontFamily: 'Nunito,sans-serif' }}
          >
            Read Book
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookListCard;
